module.exports = __webpack_public_path__ + "img/44.f09ce0ec.png";